import { Component, OnDestroy, OnInit } from "@angular/core";
import { PostMessageService } from "@shared/services/post-message.service";
import { Subject, takeUntil } from "rxjs";
import {
	InvoiceError,
	InvoiceErrorLog
} from "@data/schemas/invoice-error-response";
import { DatadogService } from "@core/services/datadog.service";
import { CustomSegmentService } from "@core/services/custom-segment.service";

@Component({
	selector: "app-invoice-errors-off-canvas",
	templateUrl: "./invoice-errors-off-canvas.component.html",
	styleUrls: ["./invoice-errors-off-canvas.component.scss"],
	standalone: false
})
export class InvoiceErrorsOffCanvasComponent implements OnInit, OnDestroy {
	private readonly TABLE_NAME = "track_nfe_error";
	private readonly SCREEN_NAME = "nfe";
	private readonly ACTION_NAME = "track_nfe_error_open_offcanvas";

	openOffCanvas = false;
	invoiceError?: InvoiceError;

	private _onDestroy$ = new Subject<boolean>();

	constructor(
		private postMessageService: PostMessageService,
		private datadogService: DatadogService,
		private segment: CustomSegmentService
	) {}

	ngOnInit(): void {
		this.postMessageService.onNewMessage$
			.pipe(takeUntil(this._onDestroy$))
			.subscribe((message) => {
				if (message.intention === "showInvoiceErrors") {
					const payloadErrorString: string = JSON.stringify(
						message.payload
					);

					const errorResponse: InvoiceError = JSON.parse(
						payloadErrorString
					) as InvoiceError;

					this.invoiceError = errorResponse;
					this.openOffCanvas = true;

					this.sendOffCanvasTracking(errorResponse.origin);
				}

				if (message.intention === "invoiceErrorLog") {
					const errorLog = message.payload as InvoiceErrorLog;
					this.datadogService.customLog("info", errorLog.message);
				}
			});
	}

	ngOnDestroy(): void {
		this._onDestroy$.next(true);
	}

	closeOffCanvas(): void {
		this.openOffCanvas = false;
	}

	private sendOffCanvasTracking(origin: string) {
		this.segment.track({
			table: this.TABLE_NAME,
			screen: this.SCREEN_NAME,
			action: this.ACTION_NAME,
			properties: {
				origin
			}
		});
	}
}
